import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus, X } from "lucide-react";

const AmazonContacts = () => {
  return (
    <div className="amazon-contacts-accordion-blk">
      <div>
        <div>
          <h2>PDM</h2>
          <h3>Larry Maulana </h3>
          <a href="mailto:lmaulana@amazon.com">lmaulana@amazon.com</a>
        </div>
      </div>
      <div>
        <div>
          <h2>CXE Partner Specialist</h2>
          <h3>Andrew Jeffree</h3>
          <a href="andyjeff@amazon.com">andyjeff@amazon.com</a>
        </div>
      </div>

      <div>
        <div>
          <h2>PSA</h2>
          <h3>Mark MacDonald</h3>
          <a href="mailto:mmarm@amazon.com">mmarm@amazon.com</a>
          <p>Amazon Connect</p>
        </div>
        <div>
          <h3>Akalanka De Silva</h3>
          <a href="mailto:akalanka@amazon.com">aakalanka@amazon.com</a>
          <p>Amazon Bedrock</p>
        </div>
      </div>
      <div>
        <div>
          <h2>AWS Exec Sponsor</h2>
          {/* <h3>Graham Zhuang </h3>
          <a href="mailto:xyzhuang@amazon.com">xyzhuang@amazon.com</a> */}
          <h3>Jackson Fairbrother</h3>
          <a href="mailto:xyzhuang@amazon.com">fairbjac@amazon.com</a>
        </div>
      </div>
    </div>
  );
};

const IcxeedContacts = () => {
  return (
    <div className="amazon-contacts-accordion-blk">
      <div>
        <div>
          <h2>Alliance Lead</h2>
          <p>Ryan Rayner</p>
          <a href="mailto:ryan.rayner@icxeed.ai">ryan.rayner@icxeed.ai</a>
        </div>
      </div>

      <div>
        <div>
          <h2>Technical Lead</h2>
          <p>Arnel Clave</p>
          <a href="mailto:arnel.clave@icxeed.ai"> arnel.clave@icxeed.ai</a>
        </div>
      </div>
      <div>
        <div>
          <h2>Sales Lead & Area Sales Leader</h2>
          <p>Ryan Rayner</p>
          <a href="mailto:ryan.rayner@icxeed.ai">ryan.rayner@icxeed.ai</a>
        </div>
      </div>
      <div>
        <div>
          <h2>Marketing Lead</h2>
          <p>Ryan Rayner</p>
          <a href="mailto:ryan.rayner@icxeed.ai">ryan.rayner@icxeed.ai</a>
        </div>
      </div>
    </div>
  );
};

const CXOrganization = () => {
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    if (isZoomed) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isZoomed]);

  return (
    <>
      <img
        onClick={() => {
          setIsZoomed(true);
        }}
        className="orgchartImage cursor-pointer transition-transform hover:scale-105"
        src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/orgchart.png"
        alt="Organizational Chart"
      />

      <AnimatePresence>
        {isZoomed && (
          <motion.div
            className="zoomed-img-blk"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="relative p-4"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
            >
              <button onClick={() => setIsZoomed(false)}>
                <X size={20} />
              </button>
              <img
                src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/orgchart.png"
                alt="Organizational Chart Zoomed"
                className="max-h-[80vh] max-w-[90vw] object-contain rounded-xl shadow-lg"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const accordionData = [
  {
    title: "AWS Contacts",
    content: <AmazonContacts />,
  },
  {
    title: "iCXeed Contacts",
    content: <IcxeedContacts />,
  },
  {
    title: "iCXeed CX / AI Organisation",
    content: <CXOrganization />,
  },
];

const AccordionSectionBlk = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="accordion-blk">
      <div className="accordion-container">
        {accordionData.map((item, index) => (
          <div
            key={index}
            className="accordion-item"
            onClick={() => {
              toggleAccordion(index);
            }}
          >
            <div className="accordion-header">
              <span className="accordion-title">{item.title}</span>
              {activeIndex === index ? (
                <Minus className="accordion-icon" size={18} />
              ) : (
                <Plus className="accordion-icon" size={18} />
              )}
            </div>

            <AnimatePresence>
              {activeIndex === index && (
                <motion.div
                  className="accordion-content"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {item.content}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccordionSectionBlk;
